import Axios from 'axios';
import config from '../config/config';
import { FormData } from '../contexts/interfaces';

const serverUrl = config.serverUrl;

const fileToBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result as string;
            const base64 = result.split(',')[1];
            if (!base64) {
                reject(new Error('Failed to read file'));
                return;
            }
            resolve(base64);
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
    });

const buildPayload = async (formData: FormData) => {
    const { formStep, attachmentFile, ...orderFields } = formData;

    const payload: Record<string, unknown> = { ...orderFields };

    if (attachmentFile) {
        payload.attachments = [{
            filename: attachmentFile.name,
            mimeType: attachmentFile.type,
            contentBase64: await fileToBase64(attachmentFile),
        }];
    }

    return payload;
};

const sendMail = async (formData: FormData) => {
    const payload = await buildPayload(formData);
    return Axios.post(`${serverUrl}/sendMail`, payload);
};

export {
    sendMail
};
